import React, { FC } from 'react';
import { Modal, H1 } from '@erecruit/ui-kit';
import { Text } from '@erecruit/ui-kit';
import { useHistory, Redirect, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectors } from './state/reducer';
import {
  BroadcastMessagePageProps,
  MapStateModal,
  BroadcastMessagePageParams,
} from './types';

const BroadcastMessagePage: FC<BroadcastMessagePageProps> = props => {
  const history = useHistory(),
    params = useParams<BroadcastMessagePageParams>(),
    messageId = Number(params.id),
    message = (props.broadcastMessages || []).find(x => x.id === messageId);

  if (!message) {
    return <Redirect to="/" />;
  }

  if (message == null) return <></>;

  const goBack = () => history.goBack(),
    pageTitle = <H1 color="headerTertiary">{message.title}</H1>,
    title = (
      <>
        <H1>{message.title}</H1>
        <Text textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
          {message.summary}
        </Text>
      </>
    );

  return (
    <Modal
      pageTitle={pageTitle}
      title={title}
      visible
      closable={true}
      footer={null}
      onCancel={goBack}
    >
      <Text>{message.body}</Text>
    </Modal>
  );
};

const mapStateToProps: MapStateModal = state => ({
  broadcastMessages: selectors.selectBroadcastMessages(state).messages,
});

export default connect(mapStateToProps, {})(BroadcastMessagePage);
